import { render, staticRenderFns } from "./FileEdit.vue?vue&type=template&id=1be09c6a&scoped=true&"
import script from "./FileEdit.vue?vue&type=script&lang=js&"
export * from "./FileEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be09c6a",
  null
  
)

export default component.exports